module.exports = __webpack_public_path__ + "static/media/proyeccion_logo.6af3e791.png";